import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/JOIN_FAMLY_LIVE_MEETING_MODAL';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (famlyLiveMeetingId: string, isMeetingCreator: boolean) => ({
        famlyLiveMeetingId,
        isMeetingCreator,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
